<!--查看争议-->
<template lang="pug">
    <el-dialog title="查看争议" width="50%" :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'>
        <el-form ref="form" :model="argureData" label-width="80px">
            <el-form-item label="提交人">
              <el-input v-model="argureData.uploadName" class="inputWidth" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="争议内容">
                <el-input type="textarea" :rows="5" v-model="argureData.content" :disabled="oprType === 'view'"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="oprType === 'edit'" type="primary" @click='submit'>提交修改</el-button>
            <el-button @click="visible = false">返回</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
  name: 'DownGradeRecorde',
  data () {
    return {
      id: '', // 争议id
      oprType: '', // 操作类型
      visible: false,
      argureData: {
        name: 'whb',
        desc: 'hahahah'
      }
    }
  },
  methods: {
    init (row, operType) {
      // this.id = id
      this.argureData = row
      this.oprType = operType
      this.visible = true
      // axios加载数据,或者从上一个界面带过来
      // this.getGameDetailData()
    },
    submit () {
      this.$http({
        url: this.$http.adornUrl(`/cbClub/updateDebateById`),
        method: 'post',
        data: this.argureData
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功')
          this.$emit('refreshData')
          this.visible = false
        } else {
          this.$message.error(data.msg)
        }
      })
    }
    // // 获取数据
    // getGameDetailData () {
    //   this.$http({
    //     url: this.$http.adornUrl(
    //       `/ctCompetition/operation/club/debate/${this.id}`
    //     ),
    //     method: 'get'
    //   }).then((data) => {
    //     if (data && data.code === 0) {
    //       this.tableData = data.data.rows
    //       this.totalPage = data.data.total
    //     } else {
    //       this.tableData = []
    //       this.totalPage = 0
    //     }
    //   })
    // }
  }
}
</script>
<style scoped>
</style>
